import type { CloudGraphVideoEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI: CloudGraphVideoEntityAti[] = [
	'ati:cloud:graph:video',
];
